import { render, staticRenderFns } from "./VPSSecurityProfilePage.vue?vue&type=template&id=b467bdfa&scoped=true"
import script from "./VPSSecurityProfilePage.vue?vue&type=script&lang=js"
export * from "./VPSSecurityProfilePage.vue?vue&type=script&lang=js"
import style0 from "./VPSSecurityProfilePage.vue?vue&type=style&index=0&id=b467bdfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b467bdfa",
  null
  
)

export default component.exports